export interface ICenterBillingRecord {
    swapNumber: string,
    donorAlias: string,
    donorUnosId: string,
    donorId: number,
    billingType: string,
    billableCenterId: number,
    billableCenterAlias: string,
    recipientAlias: string,
    recipientId: number,
    opoAlias: string,
    opoId: number,
    invoiceDate: string,
    daysOutstanding: number,
    amount: number,
    payableCenterId: number,
    payableCenterAlias: string,
    organType: number,
    payableType: string,
    isPaid: boolean
}
